import { render, staticRenderFns } from "./ClientDetailsAndForm.vue?vue&type=template&id=2bc643a6&scoped=true"
import script from "./ClientDetailsAndForm.vue?vue&type=script&lang=ts"
export * from "./ClientDetailsAndForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientDetailsAndForm.vue?vue&type=style&index=0&id=2bc643a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc643a6",
  null
  
)

export default component.exports